import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f37e307")

_pushScopeId("data-v-2f37e307")
const _hoisted_1 = { class: "no-file-selectd" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"text-align":"center","opacity":"0.25"} }, [
  /*#__PURE__*/_createVNode("h2", null, "No file selected")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2
  ]))
})